import * as queryStringFields from "../enums/queryStringFields";

function parseArrValue(val) {
	return typeof val === "string" && val.indexOf(",") !== -1 ? val.split(",") : [val];
}

export function parse(str) {
	if (!str || typeof str !== "string") {
		return {};
	}
	const queryString = str.replace(/.*?\?/, "");

	if (queryString.length) {
		const keyValPairs = queryString.split("&");
		const params = {};
		for (let i = 0; i < keyValPairs.length; i++) {
			const pair = keyValPairs[i].split("=");
			const key = pair[0];
			const val = pair[1];
			if (!key.length) continue;

			if (typeof params[key] === "undefined") {
				const end = key.slice(-2);
				params[key] =
					end === "[]" || key === queryStringFields.PROFILE_IDS_2
						? parseArrValue(val)
						: val;
			} else if (Array.isArray(params[key])) {
				params[key] = [...params[key], ...parseArrValue(val)];
			} else {
				params[key] = [params[key], val];
			}
		}
		return params;
	}

	return {};
}

export function stringify(obj) {
	return Object.keys(obj)
		.map(key => `${key}=${obj[key]}`)
		.join("&");
}
